<template>
  <div>

<van-swipe @change="onChange">
    <van-swipe-item >
     <!-- thumb="https://developer.android.com/guide/practices/ui_guidelines/images/NB_Icon_Mask_Shapes_Ext_02.gif"-->
    <van-card v-for="item in cihaz" :key="item.id"
    :title="item.barkod+' - iç lokasyon: '+item.lokasyon"
    :desc="item.alias+' - '+item.model"
    :num="item.adet+ ' Bekleyen Servis'"
    >
      <template #tags >
        <van-tag style="margin-top:5px" plain type="default">Ekip - {{$helper.ilkharfBuyuk(item.ekip)}}</van-tag>
        <van-tag style="margin-top:5px" plain type="default">{{$helper.ilkharfBuyuk('Durumu '+item.durum)}} - {{$helper.ilkharfBuyuk(item.cd)}}</van-tag>
      </template>

    </van-card>


  </van-swipe-item>
<van-swipe-item>
  
  <van-collapse v-model="activeName" accordion>
  <van-collapse-item v-for="item in gecmisi" :key="item.no" :title="item.no+' '+item.sn" :name="item.no">
    <van-cell v-for="items in item.islemler" :title="items.isi" :key="items.tsi" :value="$helper.trtgoster(items.tsi)" :label="items.msi" />
  </van-collapse-item>
</van-collapse>

</van-swipe-item>


  <van-swipe-item style="font-size:16px;">
    <van-form @submit="sendNewPost">
        <van-field v-model="newpost.cariad" name="Cari" disabled label="Müşteri" placeholder="Müşteri"/>
        <van-field  v-model="newpost.barkod" name="Barkod" label="Barkod"  placeholder="Cihaz Barkod"/>
        <van-field readonly clickable name="picker" :value="value" label="Anagrup" placeholder="Cihaz Anagrup" @click="showPicker = true"/>
        <van-field readonly clickable name="picker2" :value="value2" label="Altgrup" placeholder="Cihaz Altgrup" @click="showPicker2 = true"/>
        <van-field readonly clickable name="picker3" :value="value3" label="Durum" placeholder="Cihaz Durumu" @click="showPicker3 = true"/>
        <van-field v-model="newpost.lokasyon" name="lokasyon" label="Lokasyon" type="textarea" placeholder="Lokasyon"/>
        <div style="margin: 16px;"> 
          <van-button block type="info" native-type="submit">
            Cihaz Ekle
          </van-button>
        </div>
    </van-form>

    <div class="van-ellipsis--l3" style="font-family: 'Poppins', sans-serif; font-size:13px; color:#aaa; padding:20px"  >
      Sisteminizde kayıtlı olmayan yeni bir cihaz eklemek için kullanınız. Daha önceden kayıtlı bir cihaz ise envanter kısmından müşteriye cihaz ataması yapınız.
    </div>  
  </van-swipe-item>

  <template #indicator>
    <div class="custom-indicator"></div>
  </template>
</van-swipe>
        <van-tabbar v-model="active">
          <van-tabbar-item  :to="`/servis/${id*8589}`" icon="home-o">Genel</van-tabbar-item>
          <van-tabbar-item icon="cashier-o">Envanter</van-tabbar-item>
          <van-tabbar-item icon="browsing-history-o">Geçmiş</van-tabbar-item>
          <van-tabbar-item icon="add-o">Cihaz Ekle</van-tabbar-item>
          <van-tabbar-item icon="chart-trending-o">Analiz</van-tabbar-item>

        </van-tabbar>
<van-popup id="456" v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
<van-popup v-model="showPicker" position="bottom">
  <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
</van-popup>

<van-popup v-model="showPicker2" position="bottom">
<van-picker show-toolbar :columns="columns2" @confirm="onConfirm2" @cancel="showPicker2 = false" />
</van-popup>
<van-popup v-model="showPicker3" position="bottom">
<van-picker show-toolbar :columns="columns3" @confirm="onConfirm3" @cancel="showPicker3 = false" />
</van-popup>
</div>
</template>

<script>
import { Notify } from 'vant';
import { Dialog } from 'vant';
import { Popup } from 'vant';
import { Toast } from 'vant';

export default {
  data() {
    return {
      cihazid:'',
      value: '',
      showPicker: false,
      columns: [],
      value2: '',
      showPicker2: false,
      columns2: [],
      grup:[],
      altgrup:[],
      cdler:[],
      columns3:[],
      showPicker3: false,
      value3:'',
       activeName:'',
       value1:'',
       id:this.$route.params.id/8589,
       active: 1,
       show:false,
       error:[],
       cihaz:[],
       servis:[],
       gecmisi:[],
      table:'',
      ayar:this.$request.ayar(),
      isLoading: false,
       newpost:{
         cid:'', //cariid
         kat:'',
         barkod:'',
         durum:'',// cihaz durum aktif / pasif
         firma:this.$request.ayar().firmaid,
         lokasyon:'',
         tarih:'',
         sa:0
       },
       source:this.$store.getters.getsource

    };
  },

  created(){
    this.show = true
    this.yetki();
    //this.gecmis();
    // this.cihazgrup();
    // this.cdgetir();
  },
  methods: {
          yetki(){
            let baslat = false;
            let table ='';
              if (this.ayar.ya==='sid'){
                  this.table = 'servis'
                  baslat = true
                  this.getPostsAsync(table,baslat)
              }
              else{
                this.table = 'kayit'
                baslat=true
                this.getPostsAsync(table,baslat)
              }
          }, 
            gecmis(){

              this.$request.get("servis/gecmis/"+this.$store.getters.getaktifservis.cid+'/mikro')
              .then(res => { 
                this.gecmisi = res.sort((t1,t2) => t1.no > t2.no ? -1 : 1)
                console.log(res);
                this.show = false
              })


            },

            kaldir(){
                Dialog.confirm({
                  title: ' Cihaz Kaldıralacak ?',
                  message: 'Onaylıyormusnuz ?',
                })
                  .then(() => {})
            },
            servisler: function(){ // carinin diğer servislerini ve tüm cihazlarını gösterir
              this.show = true

              this.servis = []
              this.newpost.cid = this.$store.getters.getaktifservis.carid
              this.$request.get("servis/sd2/"+this.newpost.firma+"/"+this.newpost.cid+'/mikro')
                    .then(res => { 
                      this.servis = res.results 
                      this.cihazgetir()
                    })
            },
        cihazgetir (){


         var data = "'" + this.newpost.cid + "'"
            this.$request.post("servis/api", { q: 'cihaz_list',isim:this.$request.ayar().f1, where: { alan: 'adr.adr_Guid =', value: data, status: true } })
              .then(cihaz => {
                for (let i = 0; i < cihaz.data.length; i++) {
              var extra = this.groupByEkip(cihaz.data[i].cihazid)

                    let cihazitem = {
                      id:cihaz.data[i].cihazid,
                      barkod:cihaz.data[i].chz_serino,
                      alias:cihaz.data[i].cihazgrup,
                      model:cihaz.data[i].cihazaltgrup,
                      durum:cihaz.data[i].cd,
                      lokasyon:cihaz.data[i].lokasyon,
                      adet:extra.count,
                      ekip:extra.ekip
                    }
                    this.cihaz.push(cihazitem)

            }
            
              })



            this.gecmis()
        }, 
            groupByEkip (id){
              let count = 0;
              var ekip =''
              for (let i = 0; i < this.servis.length; i++) {
                  if (this.servis[i].cid===id){
                    count +=+1
                  ekip =this.servis[i].ekipName
                  }

              }
              return ({count:count,ekip:ekip})
            } , 
        getPostsAsync(){ //servis idye göre cari ve diğer bilgileri alma
          this.servisler()
              //   this.$request.get("servis/detay/servis/"+this.ayar.ya+"/"+this.ayar.kid+"/"+this.id+"/"+this.table)
              //   .then(res => {
              //     console.log(res)
              //     this.$store.dispatch('cari_getir')
              //     this.newpost.cid = res.servis.carid
              //     this.newpost.cariad = res.servis.cari_ad
              //     this.newpost.carikod = res.servis.cari_kod
              //     this.cihazid = res.servis.cid
              //     // this.servisler()
              //     // this.gecmis()
              //   })
              // .catch(err => {this.error.push(err)})
        },

    onConfirm(value, index) {
      this.show = true
      this.value = value;
      this.altgrupf(index)
      this.showPicker = false;
      this.altgrup = [];
      this.columns2 = [];
     
    },

    altgrupf(id){
      this.show = false
          this.$request.get("cihazaltgrup/"+this.grup[id].id)
           .then(res => {
              res.results.forEach(element => {
                this.columns2.push(element.alias);
                this.altgrup.push(
                  {
                    "id" : element.id,
                    "alias":element.alias
                  }
                )
                
                
                this.showPicker2 = true;
              });
           })
    },
    onConfirm2(value, index) {
      this.newpost.kat = this.altgrup[index].id
      this.value2 = value;
      this.show = false
      this.showPicker2 = false;
      this.showPicker3 = true;
    },
    onConfirm3(value, index) {
      this.newpost.durum = this.cdler[index].id
      this.value3 = value;
      this.show = false
      this.showPicker3 = false;
    },
    cihazgrup(){
      this.$request.get("servis/cihazgrup/"+this.newpost.firma)
      .then(res => {
        res.results.forEach(element => {
          this.columns.push(element.alias);
          this.grup.push(
            {
              "id" : element.id,
              "alias":element.alias
            }
          )
        });
       })
    },
        cdgetir() { 
          this.$request.get("servis/define/"+this.newpost.firma+"/cd")
          .then(res => {
              res.results.forEach(element => {
                this.columns3.push(element.alias);
                this.cdler.push(
                  {
                    "id" : element.id,
                    "alias":element.alias
                  }
                )
              });
         })
        .catch(err => this.errors.push(err))
        },
    sendNewPost() {
      if (this.$helper.sayfayetki(516410)){
        if (this.newpost.barkod && this.newpost.durum && this.newpost.barkod.length>5){
          this.show = true
          this.getPostsAsync2(this.newpost.barkod)
            .then(res =>{
              if (res){
                this.$request.post("servis/create/",this.newpost )
                .then(data => {
                    this.getPostsAsync2(this.newpost.barkod)
                      .then(res => {
                        if(!res){
                          Toast('Cihaz Başarı ile Eklendi');
                          this.show = false
                        }
                        else{
                          Toast('Cihaz Eklenemdi');
                          this.show = false
                        }
                      })
                      .catch(err => Toast("Cihaz Listeleme Hatası"))
                })
                .catch(err => {Toast("Sistem Hatası:Cihaz Eklenemedi")})
              }
              else{
                Toast("Barkod Mevcut");
                this.show = false
              }
            })
            .catch(err => {
             // this.$swal("Barkod Kontrol Edilemedi")
              Toast(err.mesaj)
              this.show = false

              })
        }
        else{Toast("Girdileri Kontrol Et")}
      }
      },
        getPostsAsync2(barkod) {
          return new Promise ((resolve,reject) => {
              this.$request.get('servis/cihazbarkod/'+this.newpost.firma+'/'+barkod)
                .then(data => { 
                  if (data.results.length===0){
                    resolve(true)
                  }
                  else{resolve(false)}
            })
            .catch(err => {reject({mesaj:'Sistem:Barkod Kontrol Hatası'})})
          })
        },

        onChange(index) {this.active = index+1;}
  },
};
</script>
<style>
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
  }
</style>


// WEBPACK FOOTER //
// src/components/servis/cihaz.vue